import * as React from 'react'
import { BasePage } from 'app/shared/components/base/BasePage'
import etcimg01 from 'assets/images/etc/service-end-img.png'
import etcimg02 from 'assets/images/etc/ibk-logo.png'
import useBasePage from 'app/shared/hooks/base-page.hook'
import { noTiList } from 'app/core/models/api/com/com0102'
import {
    getStringOfWeek,
    isEmpty,
    replaceTextToHtmlTag,
    setFormatTime,
} from 'app/shared/utils/comUtil'
import moment from 'moment'
import DOMPurify from 'dompurify'
/*======================================================================
 * @ 업무설명 : 종료 안내
 * @ 파 일 명 : /pages/mai/not/MAINOT0102.tsx
 * @Rest URI :
 * @ASIS :
 *======================================================================
 * 번호  작업자           작업일         변경내용
 *======================================================================
 * 1     최정기(S24068)   2025.06.09    최초작성
 *======================================================================
 */
const MAINOT0102: React.FC<{ notiInfoOb: noTiList }> = (prop) => {
    const { notiInfoOb } = prop

    if (!notiInfoOb) return <></>

    const changeFormat = (str: string) => {
        if (isEmpty(str)) {
            return
        }

        let yyyymmdd = str.substring(0, 8)
        let hhmm = str.substring(8, 12)

        let returnStr =
            moment(yyyymmdd).format('YYYY년 MM월 DD일') +
            '(' +
            getStringOfWeek(moment(yyyymmdd).format('d'), 'K') +
            ') ' +
            setFormatTime(hhmm)

        return returnStr
    }

    return (
        <BasePage
            header={false}
            prev={false}
            className="service-end center pt-0"
        >
            <img src={etcimg01} className="service-img mt-64" alt="" />
            <p className="h4 bold mt-16">서비스 점검 안내</p>
            <p className="h6 bold mt-16">
                <div
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                            replaceTextToHtmlTag(notiInfoOb?.connTtlNm)
                        ),
                    }}
                ></div>
            </p>
            <p className="service-text mt-08">
                <div
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                            replaceTextToHtmlTag(notiInfoOb?.connCon)
                        ),
                    }}
                ></div>
            </p>
            <div className="gray-list-box left mt-24">
                <p className="bold">점검일시</p>
                <p className="list-text mt-08">
                    시작일시 : {changeFormat(notiInfoOb?.expuSttgTs)} <br />
                    종료일시 : {changeFormat(notiInfoOb?.expuFnshTs)}
                </p>
            </div>
            <ul className="list-bullet left mt-12">
                <li>
                    <div className="group">
                        점검일시는 시스템 점검상황에 따라 변경될 수 있습니다.
                    </div>
                </li>
            </ul>
            <img src={etcimg02} className="ibk-logo" alt="IBK 기업은행 로고" />
        </BasePage>
    )
}

export default MAINOT0102
